module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail-container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('div', {
    staticClass: "page-actions"
  }, [(_vm.order.orderSn) ? _c('div', {
    staticClass: "order-number-badge"
  }, [_vm._v("\n        订单编号: " + _vm._s(_vm.order.orderSn) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.refreshPage
    }
  }, [_vm._v("刷新")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingOrder),
      expression: "loadingOrder"
    }],
    staticClass: "order-detail-wrapper"
  }, [(_vm.order.orderState === 6) ? _c('el-alert', {
    attrs: {
      "title": "订单已取消",
      "type": "error",
      "show-icon": "",
      "closable": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "status-card"
  }, [_c('div', {
    staticClass: "status-header"
  }, [_c('span', {
    staticClass: "status-title"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('el-tag', {
    staticClass: "status-tag",
    attrs: {
      "type": _vm.getOrderStateType(_vm.order.orderState)
    }
  }, [_vm._v("\n              " + _vm._s(_vm.getOrderStateName(_vm.order.orderState)) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "status-info"
  }, [_c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("归属人：")]), _vm._v(" "), _c('span', {
    staticClass: "status-value"
  }, [_vm._v(_vm._s(_vm.order.employee.adminName))])]), _vm._v(" "), _c('div', {
    staticClass: "status-item"
  }, [_c('span', {
    staticClass: "status-label"
  }, [_vm._v("创建时间：")]), _vm._v(" "), _c('span', {
    staticClass: "status-value"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.order.createTime)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card order-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "section-subtitle"
  }, [_vm._v("基础信息")]), _vm._v(" "), _c('div', {
    staticClass: "info-grid"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("客户名称：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.customer.customerName))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.customer.phoneNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("销售渠道：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.gettypeNameById(_vm.order.customer.typeId)))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("客户级别：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.getlabelNameById(_vm.order.customer.labelId)))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("客户来源：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.getsourceNameById(_vm.order.customer.sourceId)))])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-subtitle"
  }, [_vm._v("支付信息")]), _vm._v(" "), _c('div', {
    staticClass: "payment-highlight compact"
  }, [_c('span', {
    staticClass: "payment-label"
  }, [_vm._v("订单金额：")]), _vm._v(" "), _c('span', {
    staticClass: "payment-value"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.order.orderAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "info-grid"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("支付方式：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.payType))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("支付状态：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.getPaymentStatusType(_vm.order.paymentStatus),
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.order.paymentStatus))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-subtitle"
  }, [_vm._v("物流信息")]), _vm._v(" "), _c('div', {
    staticClass: "info-grid"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发货方式：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.logisticsMethods))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("快递公司：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.logisticsCompanies))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("快递单号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.trackingNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("收货地址：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.shippingAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section-subtitle"
  }, [_vm._v("备注与收款凭证")]), _vm._v(" "), _c('div', {
    staticClass: "info-grid"
  }, [_c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.notes || '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("物流备注：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.order.remarks || '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item full"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("收款凭证：")]), _vm._v(" "), _c('div', {
    staticClass: "receipt-container receipt-row"
  }, [(_vm.order.receipt && _vm.order.receipt.length) ? _c('div', _vm._l((_vm.order.receipt), function(img, index) {
    return _c('el-image', {
      key: index,
      staticClass: "receipt-img",
      attrs: {
        "src": img,
        "preview-src-list": _vm.order.receipt,
        "fit": "cover"
      }
    })
  }), 1) : _c('div', {
    staticClass: "no-image"
  }, [_vm._v("暂无图片")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "product-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("订单产品信息")]), _vm._v(" "), _c('div', {
    staticClass: "warehouse-info"
  }, [_c('el-tag', {
    attrs: {
      "size": "small",
      "type": "info",
      "effect": "plain"
    }
  }, [_c('i', {
    staticClass: "el-icon-location",
    staticStyle: {
      "margin-right": "4px"
    }
  }), _vm._v("发货仓库：" + _vm._s(_vm.order.stash || '—') + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "product-count-badge"
  }, [_vm._v("共 " + _vm._s(_vm.productList.length || 0) + " 件")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProducts),
      expression: "loadingProducts"
    }],
    staticClass: "product-table",
    attrs: {
      "data": _vm.productList,
      "border": "",
      "highlight-current-row": "",
      "empty-text": _vm.loadingProducts ? '正在加载产品...' : '暂无产品数据',
      "stripe": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品名称",
      "prop": "productName",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品图片",
      "prop": "picture",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticClass: "product-image",
          attrs: {
            "src": scope.row.picture,
            "preview-src-list": [scope.row.picture]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品价格",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.formatCurrency(scope.row.price)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售价",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.formatCurrency(scope.row.costPrice)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "选购数量",
      "prop": "orderNum",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成交价",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.formatCurrency(scope.row.salePrice)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.formatCurrency(scope.row.orderAmount)))]
      }
    }])
  })], 1), _vm._v(" "), (_vm.productList && _vm.productList.length) ? _c('div', {
    staticClass: "table-summary"
  }, [_c('span', [_vm._v("合计数量："), _c('b', [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('span', [_vm._v("合计金额："), _c('b', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalAmount)))])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('OrderTime', {
    attrs: {
      "order-sn": _vm.copyOrderSn,
      "show-export": true,
      "order-state": _vm.orderState
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('span', [_vm._v("订单信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6301d9f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/orderDetail.vue
// module id = 1014
// module chunks = 3